import { AsyncFilterType, QueryBuilderFilterType } from './types';

export const getIsAsyncFilterType = (
  filterType: QueryBuilderFilterType
): filterType is AsyncFilterType =>
  [
    QueryBuilderFilterType.ASYNC_COMPONENT_NAME,
    QueryBuilderFilterType.ASYNC_COMPONENT_KEY,
    QueryBuilderFilterType.ASYNC_WORKSPACE_NAME,
    QueryBuilderFilterType.ASYNC_USER,
    QueryBuilderFilterType.ASYNC_TAGS,
    QueryBuilderFilterType.ASYNC_PARENT,
    QueryBuilderFilterType.ASYNC_COMPONENT_OID,
    QueryBuilderFilterType.ASYNC_TARGET,
    QueryBuilderFilterType.ASYNC_SOURCE,
    QueryBuilderFilterType.ASYNC_ROOT_WORKSPACE,
    QueryBuilderFilterType.ASYNC_COMPONENT_TYPE_NAME,
    QueryBuilderFilterType.ASYNC_REFERENCED_COMPONENT_TYPE_NAME,
    QueryBuilderFilterType.ASYNC_REFERENCE_TYPE_NAME,
    QueryBuilderFilterType.ASYNC_REFERENCE_OID,
    QueryBuilderFilterType.ASYNC_READONLY_REFERENCE_OID,
  ].includes(filterType);
